import { render, staticRenderFns } from "./OfficersCard.vue?vue&type=template&id=b9a39610&scoped=true&"
import script from "./OfficersCard.vue?vue&type=script&lang=js&"
export * from "./OfficersCard.vue?vue&type=script&lang=js&"
import style0 from "./OfficersCard.vue?vue&type=style&index=0&id=b9a39610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a39610",
  null
  
)

export default component.exports